import React, { Suspense, useContext } from 'react';
import { WWW_ORIGIN, GET_ORIGIN } from '../../config';
import { PunchOutContext } from '../../contexts/PunchOutContext';
import Auth from '@xometry/auth-context';
import { ModalType } from '../../Component';
import { lazyWithRetries } from '../../utils/shimport';

const NavigationURL = `${WWW_ORIGIN}/quoting/components/customer-top-nav/microcomponents/navigation.mjs`;
const LazyNavigation = lazyWithRetries(NavigationURL);

const Navigation = ({
  setOpenNewQuoteModal,
}: {
  setOpenNewQuoteModal: React.Dispatch<React.SetStateAction<ModalType | null>>;
}) => {
  const { punchOut, punchoutSessionId } = useContext(PunchOutContext);
  const { user, isLoading, isStaff, isEUQuoter } = useContext(Auth);

  return (
    <Suspense fallback={<></>}>
      <LazyNavigation
        appRootBaseUrl={GET_ORIGIN}
        wwwBaseUrl={WWW_ORIGIN}
        user={user}
        isStaff={isStaff}
        isEUQuoter={isEUQuoter}
        isAuthLoading={isLoading}
        punchOut={punchOut}
        punchOutSessionId={punchoutSessionId}
        openStartNewQuoteModalFn={() =>
          setOpenNewQuoteModal(ModalType.NEW_QUOTE_MODAL)
        }
      />
    </Suspense>
  );
};

export default Navigation;
